import React from 'react';

import { withStyles, darken } from '@material-ui/core/styles';

import LoadingButton from './LoadingButton';

const CustomColorButtonGenerator = ({ bgColor, hoverBgColor, borderColor, txtColor }) => {
  return withStyles((theme) => ({
    root: {
      '&:hover': {
        backgroundColor: hoverBgColor || darken(bgColor, 0.1),
      },
      backgroundColor: bgColor,
      borderColor: borderColor || bgColor,
      color: txtColor || theme.palette.getContrastText(bgColor),
    },
  }))(LoadingButton);
};

export default (props) => {
  const { bgColor = '#2AAAE2', borderColor, children, hoverBgColor = '', txtColor = '', ...rest } = props;
  const CustomColorButton = CustomColorButtonGenerator({ bgColor, borderColor, hoverBgColor, txtColor });

  return <CustomColorButton {...rest}>{children}</CustomColorButton>;
};
